<div class="d-flex justify-content-center">
    <label class="switch m-0">
        <input
            type="checkbox"
            [checked]="value"
            (change)="onToggleChange($event.target.checked)"
            required
        />
        <span class="slider round"></span>
    </label>
</div>
